// extracted by mini-css-extract-plugin
module.exports = {"fancyCardRounded":"fancy-card-style_fancyCardRounded__qAge_","fancyCardBg":"fancy-card-style_fancyCardBg__3mE1T","active":"fancy-card-style_active__3LAxM"};